import "@styles/style.scss"; // comment it if bundle with parcel
import "@scripts/components/wishlist.js";
import "@scripts/components/mgrpbtn.js";
import { scrollToElement } from "@scripts/components/functions.js";

// its floating nav bar height, so substract this number from all smooth scroll positions
let TOP_OFFSET = 52;

// superset navigatin bar
window.ezqr = {
  nav: {}
}

/* Navigation sidebar toggler */
document.addEventListener( 'DOMContentLoaded', function() {
  const navArea = document.querySelector('.nav-area');
  const navAreaToggler = document.querySelector('.nav-toggler');
  const navAreaOverlay = document.querySelector('.nav-overlay');
  const bodyClassWhenToggled = 'sidebar--toggled';

  // Return early if the navigation doesn't exist.
  if ( 'undefined' === typeof navArea || 'undefined' === typeof navAreaToggler ) {
    return;
  }

  // Toggle the .nav-area--toggled class each time the button is clicked.
  navAreaToggler.addEventListener( 'click', function() {
    toggleState(navAreaToggler, navArea);
  } );

  if ( navAreaOverlay ) {
    navAreaOverlay.addEventListener( 'click', function(){
      if (document.body.classList.contains( bodyClassWhenToggled ))
        toggleState(navAreaToggler, navArea);
    }, true );
  }

  navArea.querySelectorAll( 'a' ).forEach(link => {
    link.addEventListener( 'click', function(){
      if (document.body.classList.contains( bodyClassWhenToggled ))
        toggleState(navAreaToggler, navArea);
    }, true );
  });

  function toggleState(toggler, targetArea) {
    toggler.classList.toggle('nav-toggler--toggled' );
    targetArea.classList.toggle('nav-area--toggled' );

    document.body.classList.toggle( bodyClassWhenToggled );

    if ( toggler.getAttribute( 'aria-expanded' ) === 'true' ) {
      toggler.setAttribute( 'aria-expanded', 'false' );
    } else {
      toggler.setAttribute( 'aria-expanded', 'true' );
    }
  }
});

const Popup = {
  root: null,
  class: '',
  splide: null,
  init: function(popupClass='popup'){
    let that = this;
    that.class = popupClass;
    that.root = document.querySelector('.' + popupClass)
    if (that.root instanceof HTMLElement) {
      let closeBtn = that.root.querySelector('.' + popupClass + '__close');
      if (closeBtn instanceof HTMLElement) {
        closeBtn.addEventListener('click', function(){
          that.trigger()
        })
      }
    }
  },
  trigger: function(move=false, index=null){
    let that = this;
    setTimeout(function(){
      that.root.classList.toggle(that.class + '--visible');
      if (move && index !== null) {
        that.splide.go(index, true);
        console.log( that.splide )
      }
      if ( that.root.classList.contains(that.class + '--visible') ) {
        that.splide.options = { keyboard: 'global' };
      } else {
        that.splide.options = { keyboard: false };
      }
    }, 150);
  },
  setSplide: function(splide){
    this.splide = splide;
  }
}

document.addEventListener( 'DOMContentLoaded', function() {

  Popup.init()

  /* ------------------- FAB - smooth scroll top ------------------------- */
  const fab = document.querySelector('.fab');
  if (fab instanceof HTMLElement) {
      let fabVisibilityHandler = function() {
        let currentHeight = window.innerHeight || document.documentElement.clientHeight|| document.body.clientHeight;
        if ( window.scrollY > (currentHeight - TOP_OFFSET) ) {
          fab.style.visibility = null;
        } else {
          fab.style.visibility = 'hidden';
        }
      }
      fabVisibilityHandler();
      ['scroll'].forEach(function(e){
        window.addEventListener(e, fabVisibilityHandler, false);
      });
      fab.addEventListener('click', function(event){
      window.scrollTo({top: TOP_OFFSET, behavior: 'smooth'});
      console.log('to top')
    })
  }

  /* Smooth scrolling for all hash nav */
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', function(event){
      event.preventDefault();
      scrollToElement(null, link.hash, TOP_OFFSET);
    });
  });

    /* ------------------- JS Tabs Nav ------------------------- */
    let tabsClass = 'tabs';
    let tabsNavItemClass = tabsClass + '__nav-item';
    let tabsNavItemActiveClass = tabsNavItemClass + '--active';
    let tabsNavPaneClass = tabsClass + '__pane';
    let tabsNavPaneActiveClass = tabsNavPaneClass + '--active';

    const navTabs = document.querySelectorAll('.' + tabsClass);
    if ( navTabs) {
      navTabs.forEach(function(navTab){
        const navTabsItems = navTab.querySelectorAll('.' + tabsNavItemClass);

        function navTabActivate(event) {
          event.preventDefault();
          let clickedTab = event.target;

          // prevent unneded changes if current
          if ( !clickedTab.classList.contains( tabsNavItemActiveClass ) ) {

            /* Dispatch tabswitch event () */
            window.dispatchEvent(
              new CustomEvent("tabswitch", {
                bubbles: true,
                detail: { tabId: () => clickedTab.dataset?.tabId },
            }));

            for (let i = 0; i < navTabsItems.length; i++) {
              if (navTabsItems[i].dataset.tabId == clickedTab.dataset?.tabId) {
                navTabsItems[i].classList.add(tabsNavItemActiveClass);
              } else {
                navTabsItems[i].classList.remove(tabsNavItemActiveClass);
              }
            }
    
            let tabContentPanes = navTab.querySelectorAll('.' + tabsNavPaneClass);
            for (i = 0; i < tabContentPanes.length; i++) {
                tabContentPanes[i].classList.remove(tabsNavPaneActiveClass);
            }
            
            /* Get Tab ID from data-tab-id */
            let tabId = clickedTab.dataset?.tabId;
            let tabContentPane = navTab.querySelector('#' + tabId);
            if (tabContentPane instanceof HTMLElement) {
              tabContentPane.classList.add(tabsNavPaneActiveClass);
            } else {
              console.warn('Nav: tab pane not found');
            }
  
            /* Update */
            try {
              let tabPosition = clickedTab.getBoundingClientRect().top + window.scrollY;
              let tabPanePosition = tabContentPane.getBoundingClientRect().top + window.scrollY;

              /* if second nav exists - nav in start section */
              if (tabPosition > tabPanePosition) {
                // window.scrollTo({top: tabPanePosition, behavior: 'smooth'});
                scrollToElement(tabContentPane, '', TOP_OFFSET)
              }
            } catch (error) {
              console.warn('Tab navigation error');
            }

          }
          
        }
        
        if ( navTabsItems ) {
          for (i = 0; i < navTabsItems.length; i++) {
              navTabsItems[i].addEventListener("click", navTabActivate)
          }
        }
      })
    }
    
    /* ------------------- Sticky Nav Menu ------------------------- */
    var stickyStartPos = -1;
    const ezqrNavBars = document.querySelectorAll('.js-ez-nav-endless');
    
    function findPositionY(element) {
      let currentTop = 0;
      if ( element.offsetParent !== null && element.offsetParent ) {
        while (element.offsetParent) {
          currentTop += element.offsetTop;
          element = element.offsetParent;
        }
        currentTop += element.offsetTop;
      } else if (element.y) {
        currentTop += element.y;
      }
      return currentTop;
    }

    let navigationScrollingHandler = function(){
      ezqrNavBars.forEach(ezqrNavBar => {
        if (stickyStartPos < 0) {
          stickyStartPos = findPositionY(ezqrNavBar);
        }
        if (window.scrollY > stickyStartPos - TOP_OFFSET) {
          ezqrNavBar.classList.add("ez-nav-endless--sticky");
        } else {
          ezqrNavBar.classList.remove("ez-nav-endless--sticky");
        }
      });
    };

    /* NOTE: custom event tabswith dispatched if tabs changed */
    ['scroll', 'resize','tabswitch'].forEach(function(e){
      window.addEventListener(e, navigationScrollingHandler, false);
    });

  /* ------------------- Sliders (navigation) ------------------------- */
  if ( window['Splide'] ) {
    /* ------------------- Categories List in Superset ------------------------- */
    const spliders = document.querySelectorAll('.js-ez-nav .splide');
    spliders.forEach(splider => {

      let currentNavElementsCount = splider.querySelectorAll('.splide__list .splide__slide').length
      const SPLIDE_MIN_ELEMENTS = 4;

      // let clonesCount = currentNavElementsCount < SPLIDE_MIN_ELEMENTS ? 0 : 2;
      let clonesCount = 0;

      let menuNavCarousel = new Splide( splider, {
        type   : 'loop',
        // type   : 'slide',
        clones : clonesCount,
        rewind : false,
        focus  : 0,
        speed  : 330,
        drag   : true,
        gap    : '10px',
        omitEnd : true,
        autoplay : false,
        mediaQuery : 'min',
        pagination : false,
        trimSpace: false,
        autoHeight : true,
        updateOnMove: true,
      }
    );
    
    /* Updates the bar width whenever the carousel moves */
    let progressbar = menuNavCarousel.root.querySelector( '.splide__progress-bar' );
    if (progressbar) {
      menuNavCarousel.on( 'mounted move', function () {
        var end  = menuNavCarousel.Components.Controller.getEnd() + 1;
        var rate = Math.min( ( menuNavCarousel.index + 1 ) / end, 1 );
        progressbar.style.width = String( 100 * rate ) + '%';
      } );
    }
    
    // /* Move carousel when slide clicked */
    menuNavCarousel.on( 'click', function (Slide, e) {
        menuNavCarousel.go(Slide.index);
    });
    
    /* Mount carousel element */
    menuNavCarousel.mount();

    /* Add to global navs list */
    if (splider.dataset?.superset) window.ezqr.nav[splider.dataset?.superset] = menuNavCarousel;

  });

  /* ------------------- Global Items Popup Slider ------------------------- */
  const popupSplideElement = document.querySelector('.popup__nav .splide');
  if (popupSplideElement instanceof HTMLElement) {
    let popupSplide = new Splide( popupSplideElement, {
        type   : 'loop',
        clones : 0,
        rewind : false,
        focus  : 'center',
        speed  : 200,
        drag   : true,
        omitEnd : true,
        autoplay : false,
        mediaQuery : 'min',
        pagination : false,
        trimSpace: true,
        updateOnMove: true,
        autoHeight : true,
        width: '100%'
      }
    );
    
    /* background page navigation while slider item move */
    popupSplide.on('move', function(){
      ezItemDataId = popupSplide.Components.Slides.getAt( popupSplide.index ).slide.querySelector('.popup__item').dataset.id ;
      ezItemOnPage = document.querySelector('.ez-menus .ez-item[data-id="' + ezItemDataId + '"]')
      scrollToElement( ezItemOnPage, '', TOP_OFFSET);
    });

    popupSplide.on('mounted', function(){
      Popup.setSplide(popupSplide);
    })

    popupSplide.mount();
  }
  } else {
    console.warn('Splide: not detected, remove additional classes');
    document.querySelectorAll('.splide').forEach(splider => {
      splider.classList.remove('splide');
    })
  }


  /* ------------------- Track Menus Position ------------------------- */
  const endlessNavBar = document.querySelector('.js-ez-nav-endless');
  const categories = document.querySelectorAll('.ez-category');
  const supersets = document.querySelectorAll('.ez-menu-superset');

  supersets.forEach(s=>{
    if (s.parentElement.parentElement.classList.contains('tabs__pane--active')) {
      s.classList.add('is-active')
    }
  });

  let topActivatePosition = 96;
  let bottomDeactivatePosition = topActivatePosition; //120;

  let next = null;
  let current = null;
  let prev = null;
  
  window.addEventListener('scroll', function(){
  
    for(let i = 0; i < supersets.length; i++) {
      let scRect = supersets[i].getBoundingClientRect();
      let scHash = supersets[i].dataset?.superset || '';
      let scNav = endlessNavBar.querySelector('.ez-nav[data-superset="' + scHash + '"]');
      // console.log(endlessNavBar, scNav, scHash);
      if ( scRect.top < topActivatePosition && scRect.bottom > bottomDeactivatePosition ) {
        if ( !supersets[i].classList.contains('is-active') ) {
          supersets[i].classList.add('is-active');
          scNav.classList.add('is-active');
          next = supersets[i+1];
          current = supersets[i]
          prev = supersets[i-1];
        }
      } else {
        supersets[i].classList.remove('is-active')
        scNav.classList.remove('is-active');
      }
    }
    // for(let i = 0; i < supersets.length; i++) {
    //   let supersetClientRect = supersets[i].getBoundingClientRect();
    //   if ( supersetClientRect.top < topActivatePosition && supersetClientRect.bottom > bottomDeactivatePosition ) {
    //     // console.log(supersets[i], supersetClientRect.bottom)
    //     if ( !supersets[i].classList.contains('is-active') ) {
    //       supersets[i].classList.add('is-active');
    //       endlessNavBar.querySelector('.ez-nav[data-superset="' + supersets[i].dataset?.superset + '"]').classList.add('is-active');
    //     }
    //   } else {
    //     supersets[i].classList.remove('is-active')
    //     endlessNavBar.querySelector('.ez-nav[data-superset="' + supersets[i].dataset?.superset + '"]').classList.remove('is-active');
    //   }
    // }

    // supersets.forEach(superset => {
    //   let supersetClientRect = superset.getBoundingClientRect();
    //   if ( supersetClientRect.top < topActivatePosition && supersetClientRect.bottom > bottomDeactivatePosition ) {
    //     if ( !superset.classList.contains('is-active') ) {
    //       superset.classList.add('is-active');
    //       endlessNavBar.querySelector('.ez-nav[data-superset="' + superset.dataset?.superset + '"]').classList.add('is-active');
    //     }
    //   } else {
    //     superset.classList.remove('is-active')
    //     endlessNavBar.querySelector('.ez-nav[data-superset="' + superset.dataset?.superset + '"]').classList.remove('is-active');
    //   }
    // });

    categories.forEach(category => {
      let superset = category.dataset.superset;
      let supersetNav = superset != undefined && window.ezqr.nav[superset] != undefined ? window.ezqr.nav[superset] : '';
      let index = category.dataset?.index != undefined ? parseInt(category.dataset?.index, 10): undefined;

      let sectionClientRect = category.getBoundingClientRect();
      if ( sectionClientRect.top < topActivatePosition && sectionClientRect.bottom > bottomDeactivatePosition ) {
        // TODO: track active state
        if ( !category.classList.contains('is-active') ) {
          
          category.classList.add('is-active')

          // console.log(supersetNav.index, index);
          if ( superset != undefined && index != undefined && supersetNav != undefined) {
            if ( supersetNav.index != index) {
              supersetNav.go(index);
            }
          }
        }
      } else {
        category.classList.remove('is-active')
      }
    });

  }, false);
/*--------------------------------------------------------------------------------------------------------------------*/

    let ezItems = document.querySelectorAll('.ez-menus .ez-item');
    ezItems.forEach(ezItem => {
      ezItem.addEventListener('click', function(event){
        goToIndex = null;
        if (Popup.splide !== null) {

          slides = Popup.splide.Components.Slides.filter('[data-slide-id="' + ezItem.dataset?.id + '"]');
          if (slides.length && slides[0]) {
            goToIndex = slides[0].index
          } 
        }
        
        if (goToIndex !== null) {
          Popup.trigger(true, goToIndex);
        } else {
          Popup.trigger();
        }

      })
    });


    Popup.root.querySelectorAll('.readmore').forEach(readmore => {
      readmore.addEventListener('click', function(event){
        popupContentClass = 'popup__item-content';
        popupContent = readmore.closest('.' + popupContentClass);
        popupContent.classList.toggle(popupContentClass + '--toggled');
        readmore.classList.toggle('readmore--toggled');
      });
    })

} );
